import * as apiTypes from './labels.apiV2.types';

import { fetch } from 'fetch';

export const getAllLabelsV2: apiTypes.GetAllLabelsV2 = params => {
  return fetch({
    url: '/v2/labels',
    method: 'GET',
    params,
    shouldDisableQueryParamsArrayFormatting: true
  });
};

export const getLabelsByIdsV2: apiTypes.GetLabelsByIdsV2 = ids => {
  return fetch({
    url: '/v2/labels',
    method: 'GET',
    params: { id: ids, limit: ids.length },
    shouldDisableQueryParamsArrayFormatting: true
  });
};

export const modifyLabelV2: apiTypes.ModifyLabelV2 = ({ id, params }) => {
  return fetch({
    url: `/v2/labels/${id}`,
    method: 'PATCH',
    params
  });
};

export const createLabelV2: apiTypes.CreateLabelV2 = params => {
  return fetch({
    url: `/v2/labels`,
    method: 'POST',
    params
  });
};

export const deleteLabelV2: apiTypes.DeleteLabelV2 = id => {
  return fetch({
    url: `/v2/labels/${id}`,
    method: 'DELETE'
  });
};
